<template>
    <form @submit.prevent="submit" id="card_to_card_form" class="bg-white p-3 rounded">

        <kt-form-section is_first>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="farsi_name">
                            {{ $t('label.farsi_name') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <kt-form-control
                            id="farsi_name"
                            name="farsi_name"
                            v-model="form_data.farsi_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="english_name">
                            {{ $t('label.english_name') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <kt-form-control
                            id="english_name"
                            name="english_name"
                            v-model="form_data.english_name"
                            dir="ltr"

                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>

        <kt-form-section>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="website">
                            {{ $t('label.website_address') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <kt-form-control
                            id="website"
                            name="website"
                            v-model="form_data.website"
                            dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="server_ip">
                            {{ $t('label.server_ip') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <kt-form-control
                            id="server_ip"
                            name="server_ip"
                            v-model="form_data.server_ip"
                            dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="callback_address">
                            {{ $t('label.callback_address') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <kt-form-control
                            id="callback_address"
                            name="callback_address"
                            v-model="form_data.callback_address"
                            dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="wage">
                            {{ $t('label.wage') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <select
                            id="wage"
                            name="wage"
                            v-model="wage"
                            class="form-control kt-selectpicker"
                        >
                            <option
                                v-for="wage_data in wages"
                                v-bind:key="wage_data.id"
                                :value="wage_data.id"
                            >
                                {{ wage_data.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>

                <kt-col v-show="wage == 50" id="merchant_wage_share_column" lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="merchant_wage_share">
                            {{ $t('label.merchant_wage_share') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <input
                            type="number"
                            max="100"
                            min="0"
                            id="merchant_share_percent"
                            name="merchant_share_percent"
                            v-model="form_data.merchant_share_percent"
                            class="form-control kt-selectpicker"
                            @change="changeWagePercent"
                        >
                    </kt-form-group>
                </kt-col>
                <kt-col v-show="wage == 50" id="client_wage_share_column" lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="client_share_percent">
                            {{ $t('label.client_wage_share') }}<span style="color: red">{{ ' *' }}</span>
                        </kt-form-label>
                        <input
                            type="number"
                            max="100"
                            min="0"
                            id="client_share_percent"
                            name="client_share_percent"
                            disabled
                            class="form-control kt-selectpicker"
                        >
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <label>
                        {{ $t("label.logo") }}<span style="color: red">{{ ' *' }}</span>
                    </label>
                    <label
                        for="logo_file"
                        class="d-block btn btn-secondary btn-wide label-file"
                    >
                        <kt-icon type="fa" name="paperclip"></kt-icon>
                        {{ $t("gateway.btn.click_me") }}
                    </label>
                    <input
                        @change="processLogoFile"
                        type="file"
                        class="custom-file-upload d-none"
                        name="logo"
                        id="logo_file"
                        accept="image/*"
                    />
                </kt-col>
                <kt-col lg="6" md="6" xs="12" class="d-flex justify-content-end">
                    <img :src="picPreview" class="preview_picture" v-if="picPreview !== ''"/>
                    <i class="fa fa-window-close text-danger remove_picture" v-if="picPreview !== ''"
                       @click="removePicture"></i>
                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-section>
            <div id="gateway_cards_div" style="margin-top: 40px">
                <label for="gateway_cards" style="font-size:medium">
                    {{ $t('card_to_card.gateway_cards') }}
                    <hr>
                </label>
                <div class="row" v-for="(card,index) in gateway_cards" v-bind:key="index">
                    <div class="col-6">
                        <label
                            for="gateway_cards" style="font-size:small;margin-bottom: 15px;margin-top: 25px">
                            {{ $t('card_to_card.card_details') }}{{ $t('ordinal_numbers.' + [index + 1]) }}
                        </label>
                    </div>
                    <div class="col-6" style="text-align: end">
                        <div style="display:inline-block;margin-top: 26px">
                            <button
                                type="button"
                                @click="removeGatewayCard(index)"
                                class="btn btn-danger px-4"
                                style="border-radius: 10px"
                                id="remove_gateway_card_btn"
                            >
                                <span>حذف</span>
                            </button>
                        </div>
                    </div>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group style="position: relative">
                            <kt-form-label for="card_number">
                                {{ $t('label.card_number') }}
                            </kt-form-label>
                            <kt-form-control
                                style="padding-left: 50px"
                                dir="ltr"
                                :id="'card_number'+ index"
                                class="form-control"
                                :name="'card_number'+index"
                                v-model="card.card_number"
                            >
                            </kt-form-control>
                            <p style="position:absolute;left: 13px;top: 34px">603769</p>
                            <p :id="'card_number_error'+index" class="field-error"></p>
                        </kt-form-group>
                        <p style="font-size: xx-small;color: red;">{{$t('card_to_card.message.only_saderat_is_supported')}}</p>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="account_number">
                                {{ $t('label.account_number') }}
                            </kt-form-label>
                            <kt-form-control
                                dir="ltr"
                                :id="'account_number'+ index"
                                class="form-control"
                                :name="'account_number'+index"
                                v-model="card.account_number"
                            >
                            </kt-form-control>
                            <p :id="'account_number_error'+index" class="field-error"></p>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="card_owner_name">
                                {{ $t('card_to_card.card_owner_name') }}
                            </kt-form-label>
                            <kt-form-control
                                dir="rtl"
                                :id="'card_owner_name'+ index"
                                class="form-control"
                                :name="'card_owner_name'+index"
                                v-model="card.card_owner_name"
                            >
                            </kt-form-control>
                            <p :id="'card_owner_name_error'+index" class="field-error"></p>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="bank_id">
                                {{ $t('label.bank') }}
                            </kt-form-label>
                            <kt-form-control
                                dir="rtl"
                                :id="'bank_id'+ index"
                                disabled
                                class="form-control"
                                :name="'bank_id'+index"
                                value="صادرات"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </div>
                <div class="row" style="padding-right: 20px;margin-top: 30px">
                    <button
                        type="button"
                        @click="addGatewayCard"
                        class="btn btn-success px-4"
                        style="border-radius: 10px"
                        id="add_gateway_card_btn"
                    >
                        <span> افزودن کارت جدید</span>
                    </button>
                </div>
            </div>
        </kt-form-section>

        <kt-form-action class="mt-4" style="margin-top: 40px!important;text-align: end">
            <kt-button
                class="btn-wide"
                size="md"
                variant="success"
                type="submit"
                v-bind:wide="true"
                id="submit_btn"
            >
                {{ $t('btn.submit') }}
            </kt-button>
        </kt-form-action>
    </form>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'

export default {
    props: {
        submit: {
            default: () => {
            },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 50,
                    value: this.$t('gateway.wages.half')
                }
            ],
            wage: 0,
            new_access_ip: null,
            picPreview: '',
            gateway_cards : []
        }
    },
    mounted() {
        this.form_data.gateway_cards = []
        this.afterDispatch()
        this.form_data.merchant_share_percent = 0
        this.gateway_cards.push( {
            card_number: '',
            account_number: '',
            card_owner_name: '',
        })
    },
    watch :{
        wage: function(wage) {
            if (wage === 0) {
                this.form_data.merchant_share_percent = 0
                let client_share_percent = $('#client_share_percent')
                client_share_percent.val(100)
            } else if (wage === 50) {
                this.form_data.merchant_share_percent = 50
                let client_share_percent = $('#client_share_percent')
                client_share_percent.val(50)
            } else if (wage === 100) {
                this.form_data.merchant_share_percent = 100
                let client_share_percent = $('#client_share_percent')
                client_share_percent.val(0)
            }
        },
        gateway_cards() {
            this.form_data.gateway_cards = this.gateway_cards

        }
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        changeWagePercent() {
            if (this.wage != 50)
                return;
            let client_share_percent = $('#client_share_percent')
            client_share_percent.val(100 - this.form_data.merchant_share_percent)
        },
        processLogoFile(e) {
            this.form_data.logo = event.target.files[0];
            this.picPreview = URL.createObjectURL(e.target.files[0]);
            if (this.validateSize(event.target)) {
                this.validateFormat(event.target);
            }
        },
        removePicture() {
            this.picPreview = ''
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, "");
            if (extension === file_name) {
                extension = "";
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case "png":
                case "jpeg":
                case "jpg":
                    break;
                default:
                    alert(i18n.t("authenticate.input_format_err"));
                    $(file).val("");
                    this.form_data.logo = null;
                    return false;
            }

            return true;
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t("authenticate.hint.fourth"));
                $(file).val("");
                this.form_data.logo = null;
                return false;
            }

            return true;
        },
        addGatewayCard() {
            if (this.gateway_cards.length > 9)
                return this.toastr.error(i18n.t('card_to_card.message.adding_cards_limit'))
            this.gateway_cards.push({
                card_number: '',
                account_number: '',
                card_owner_name: '',
            })
        },
        removeGatewayCard(index) {
            this.gateway_cards.splice(index, 1)
        },
        validateCard(code) {
            var l = code.length;
            if (l < 16 || parseInt(code.substr(1, 10), 10) == 0 || parseInt(code.substr(10, 6), 10) == 0) return false;
            var c = parseInt(code.substr(15, 1), 10);
            var s = 0;
            var k, d;
            for (var i = 0; i < 16; i++) {
                k = (i % 2 == 0) ? 2 : 1;
                d = parseInt(code.substr(i, 1), 10) * k;
                s += (d > 9) ? d - 9 : d;
            }
            return ((s % 10) == 0);
        },
        getBankName(index) {
            var number = this.form_data.gateway_cards[index].card_number.substring(6, -16);
            if (number === '603799') {
                return 'بانک ملی'
            }
            if (number === '589210') {
                return 'بانک سپه'
            }
            if (number === '627961') {
                return 'بانک صنعت و معدن'
            }
            if (number === '603770') {
                return 'بانک کشاورزی'
            }
            if (number === '628023') {
                return 'بانک مسکن'
            }
            if (number === '627760') {
                return 'پست بانک ایران'
            }
            if (number === '502908') {
                return 'بانک توسعه تعاون'
            }
            if (number === '627412') {
                return 'بانک اقتصادنوین'
            }
            if (number === '622106') {
                return 'بانک پارسیان'
            }
            if (number === '502229') {
                return 'بانک پاسارگاد'
            }
            if (number === '627488') {
                return 'بانک کارآفرین'
            }
            if (number === '621986') {
                return 'بانک سامان'
            }
            if (number === '639346') {
                return 'بانک سینا'
            }
            if (number === '639607') {
                return 'بانک سرمایه'
            }
            if (number === '502806' || number === '504706') {
                return 'بانک شهر'
            }
            if (number === '502938') {
                return 'بانک دی'
            }
            if (number === '603769') {
                return 'بانک صادرات'
            }
            if (number === '610433') {
                return 'بانک ملت'
            }
            if (number === '627353' || number === '585983') {
                return 'بانک تجارت'
            }
            if (number === '589463') {
                return 'بانک رفاه'
            }
            if (number === '627381') {
                return 'بانک انصار'
            }
            if (number === '639599') {
                return 'بانک قوامین'
            }
            if (number === '504172') {
                return 'بانک رسالت'
            }
            if (number === '606373') {
                return 'بانک مهر ایران'
            }
            if (number === '636214') {
                return 'بانک آینده'
            }
            if (number === '505785') {
                return 'بانک ایران زمین'
            }
            if (number === '627648' || number === '207177') {
                return 'بانک توسعه صادرات ایران'
            }
            if (number === '636949') {
                return 'بانک حکمت ایرانیان'
            }
            if (number === '505416') {
                return 'بانک گردشگری'
            }
            if (number === '636795') {
                return 'بانک مرکزی'
            }
        }
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.preview_picture {
    width: 50%;
    height: 150px;
}

.remove_picture {
    cursor: pointer;
    position: absolute;
    top: -5px;
}

.field-error {
    font-size: x-small;
    color: #fd397a;
    margin-top: 5px
}
</style>